import React from 'react';
import Head from 'next/head';
import { Helmet } from 'react-helmet';

export interface MetaTagGeneratorProps {
  metaTitle?: string;
  metaDescription?: string;
  metaImage?: string;
  metaUrl?: string;
  forceNoIndex?: boolean;
  noFollow?: boolean;
  noCanonical?: boolean;
}

const MetaTagGenerator: React.FC<MetaTagGeneratorProps> = ({
  metaTitle,
  metaDescription,
  metaImage,
  metaUrl,
  forceNoIndex,
  noFollow,
  noCanonical,
}) => {
  const commonMeta = [
    {
      name: 'viewport',
      content: 'width=device-width, initial-scale=1',
    },
    {
      name: 'description',
      content:
        metaDescription ||
        "World's top brands rely on Quattr for growing web traffic from search engines. Lower your overall cost per acquisition and break free from competition",
    },
    { property: 'og:locale', content: 'en_US' },
    { property: 'og:type', content: 'website' },
  ];
  if (['production'].includes(process.env.NEXT_PUBLIC_APP_ENV || '') && forceNoIndex) {
    commonMeta.push(
      { property: 'robots', content: noFollow ? 'noindex, nofollow' : 'noindex' },
      { property: 'googlebot', content: noFollow ? 'noindex, nofollow' : 'noindex' },
      { name: 'robots', content: noFollow ? 'noindex, nofollow' : 'noindex' },
      { name: 'googlebot', content: noFollow ? 'noindex, nofollow' : 'noindex' }
    );
  }
  const metaData = ['production'].includes(process.env.NEXT_PUBLIC_APP_ENV || '')
    ? [
        ...commonMeta,
        { property: 'og:title', content: metaTitle || 'Quattr Inc | Grow Your Web Traffic 2X Faster' },
        {
          property: 'og:description',
          content:
            metaDescription ||
            "World's top brands rely on Quattr for growing web traffic from search engines. Lower your overall cost per acquisition and break free from competition",
        },
        { property: 'og:url', content: metaUrl || `https://www.quattr.com` },
        { property: 'og:site_name', content: 'Quattr' },
        { property: 'og:image', content: metaImage ? `https:${metaImage}` : `https://www.quattr.com/og-image_A.jpg` },
        {
          property: 'og:image:secure_url',
          content: metaImage ? `https:${metaImage}` : `https://www.quattr.com/og-image_A.jpg`,
        },
        { property: 'og:image:width', content: '1369' },
        { property: 'og:image:height', content: '1027' },
        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:domain', content: 'quattr.com' },
        { name: 'twitter:url', content: metaUrl || `https://www.quattr.com` },
        {
          name: 'twitter:description',
          content:
            metaDescription ||
            "World's top brands rely on Quattr for growing web traffic from search engines. Lower your overall cost per acquisition and break free from competition",
        },
        { name: 'twitter:title', content: metaTitle || 'Quattr Inc | Grow Your Web Traffic 2X Faster' },
        { name: 'twitter:site', content: '@Quattr' },
        { name: 'twitter:image', content: metaImage ? `https:${metaImage}` : `https://www.quattr.com/og-image_A.jpg` },
        {
          name: 'twitter:image:src',
          content: metaImage ? `https:${metaImage}` : `https://www.quattr.com/og-image_A.jpg`,
        },
        { name: 'twitter:creator', content: '@Quattr' },
      ]
    : [
        ...commonMeta,
        { property: 'robots', content: noFollow ? 'noindex, nofollow' : 'noindex' },
        { property: 'googlebot', content: noFollow ? 'noindex, nofollow' : 'noindex' },
        { name: 'robots', content: noFollow ? 'noindex, nofollow' : 'noindex' },
        { name: 'googlebot', content: noFollow ? 'noindex, nofollow' : 'noindex' },
        {
          property: 'og:title',
          content: metaTitle || `[${process.env.NEXT_PUBLIC_APP_ENV}] Quattr Inc | Grow Your Web Traffic 2X Faster`,
        },
      ];

  return (
    <>
      <Head>
        <title>
          {metaTitle ||
            (['production'].includes(process.env.NEXT_PUBLIC_APP_ENV || '')
              ? 'Quattr Inc | Grow Your Web Traffic 2X Faster'
              : `[${process.env.NEXT_PUBLIC_APP_ENV}] Quattr Inc | Grow Your Web Traffic 2X Faster`)}
        </title>
        {['production'].includes(process.env.NEXT_PUBLIC_APP_ENV || '') && !noCanonical ? (
          <link rel="canonical" href={metaUrl || `https://www.quattr.com`} />
        ) : null}
      </Head>

      <Helmet htmlAttributes={{ lang: 'en' }} meta={metaData}></Helmet>
    </>
  );
};

export default MetaTagGenerator;
